import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';

import homeImg from '@/images/home.svg';

import s from './breadcrumbs.module.css';

function Breadcrumbs() {
  const i18n = useSelector(appSelectors.translation);

  const { pathname } = useLocation();

  const [pathData, setPathData] = useState([]);

  useEffect(() => {
    setPathData(pathname.split('/').splice(1));
  }, [pathname]);

  return pathname === '/' ? (
    <Link to="/">
      <img src={homeImg} alt="home" className={s.home_img} />
    </Link>
  ) : (
    <div className={s.breadcrumbs}>
      <Link to="/">
        <img src={homeImg} alt="home" className={s.home_img} />
      </Link>
      {pathData?.length > 0 &&
        pathData.map((item, index) =>
          index + 1 < pathData.length ? (
            <Link
              key={`${item}-${index}`}
              to={pathData.slice(0, index + 1).join('/')}
              className={s.parent}
            >
              {i18n[item] || item}
            </Link>
          ) : (
            <span key={`${item}-${index}`} className={s.child}>
              {i18n[item] || item}
            </span>
          ),
        )}
    </div>
  );
}

export default Breadcrumbs;
